import HttpBase from './HttpBase'
import { EventBus } from "@/EventBus";

export default class RestBase extends HttpBase {

    constructor(base, resource, isAuth, id = 'id') {
        super(base + resource, isAuth)
        this._id = id;
    }

    findById(id) {
        EventBus.$emit('LOADING')
        return this.get(`/${id}`)
    }

    findAll(sort = ['descricao,ASC']) {
        EventBus.$emit('LOADING')
        sort = sort.join('&sort=');
        return this.get(`/findAll?sort=${sort}`)
    }

    findPaginated(pageNumber, pageSize = 10, sort = ['descricao,ASC']) {
        EventBus.$emit('LOADING')
        sort = sort.join('&sort=');
        return this.get(`/?page=${pageNumber}&size=${pageSize}&sort=${sort}`)
    }

    findByFilter(filtro, sort = ['descricao,ASC']) {
        EventBus.$emit('LOADING')
        sort = sort.join('&sort=');
        return this.post(`/findByFilter?&sort=${sort}`, filtro)
    }

    findByFilterPaginated(filtro, pageNumber = 0, pageSize = 10, sort = ['descricao,ASC']) {
        EventBus.$emit('LOADING')
        sort = sort.join('&sort=');
        return this.post(`/findByFilterPaginated?page=${pageNumber}&size=${pageSize}&sort=${sort}`, filtro)
    }

    findToAutoComplete(f) {
        return this.get(`/findToAutoComplete/${f.descricao}`)
    }

    deleteById(id) {
        EventBus.$emit('LOADING')
        return this.delete(`/${id}`)
    }

    saveOrUpdateItem(obj) {
        EventBus.$emit('LOADING')
        if (this.getId(obj)) {
            return this.put('', obj)
        } else {
            return this.post('', obj)
        }
    }

    downloadBase64(obj) {
        return this.post('/downloadRelatorio', obj).then(res => {
            if (res) {
                var a = window.document.createElement("a");
                a.href = 'data:'+ res.mimetype + res.base64;
                a.download = res.filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        })
    }

    getId(record) {
        if (typeof record === 'object') {
            return record[this._id]
        }
        return String(record)
    }
}